import { useCallback, useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { MARKET_VIEW_MODES, VIEW_MODES } from './PointOfSalePlanogramHelpers';

const MACHINE_VIEW_MODE_STORAGE_KEY = 'pos_planogram_machine_view_mode';
const MARKET_VIEW_MODE_STORAGE_KEY = 'pos_planogram_market_view_mode';

// Grid/list (machines) and products/assets (markets) view modes, remembered on the device.
const usePointOfSalePlanogramViewModes = (width) => {
	const [viewMode, setViewMode] = useState(width < 390 ? VIEW_MODES.LIST : VIEW_MODES.GRID);
	const [marketViewMode, setMarketViewMode] = useState(MARKET_VIEW_MODES.PRODUCTS);

	useEffect(() => {
		let isSubscribed = true;

		const loadPersistedViewModes = async () => {
			try {
				const [savedMachineViewMode, savedMarketViewMode] = await Promise.all([
					AsyncStorage.getItem(MACHINE_VIEW_MODE_STORAGE_KEY),
					AsyncStorage.getItem(MARKET_VIEW_MODE_STORAGE_KEY),
				]);
				if (!isSubscribed) {
					return;
				}
				if (Object.values(VIEW_MODES).includes(savedMachineViewMode)) {
					setViewMode(savedMachineViewMode);
				}
				if (Object.values(MARKET_VIEW_MODES).includes(savedMarketViewMode)) {
					setMarketViewMode(savedMarketViewMode);
				}
			}
			catch (error) {
				// Ignore storage read failures and keep defaults.
			}
		};

		void loadPersistedViewModes();

		return () => {
			isSubscribed = false;
		};
	}, []);

	const handleSetMachineViewMode = useCallback((nextViewMode) => {
		setViewMode(nextViewMode);
		void AsyncStorage.setItem(MACHINE_VIEW_MODE_STORAGE_KEY, nextViewMode);
	}, []);

	const handleSetMarketViewMode = useCallback((nextViewMode) => {
		setMarketViewMode(nextViewMode);
		void AsyncStorage.setItem(MARKET_VIEW_MODE_STORAGE_KEY, nextViewMode);
	}, []);

	return {
		viewMode,
		marketViewMode,
		handleSetMachineViewMode,
		handleSetMarketViewMode,
	};
};

export default usePointOfSalePlanogramViewModes;
